module.exports = __webpack_public_path__ + "static/media/pep-circle-mietwagen.f42d70a5.png";